var _rect, _circle, _circle2, _circle3, _text, _text2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1262_7",
    "data-name": "Component 1262 \\u2013 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 366,
    height: 272,
    viewBox: "0 0 366 272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 366,
    height: 272,
    fill: "var(--bgColor)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(343 29)",
    fill: "#717171"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2-2",
    "data-name": "Ellipse 2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(343 34)",
    fill: "#717171"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2-3",
    "data-name": "Ellipse 2",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(343 39)",
    fill: "#717171"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_5_156_894",
    "data-name": "5,156,894",
    transform: "translate(183 201.753)",
    fill: "#606060",
    fontSize: 48,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -108.672,
    y: 0
  }, "5,156,894"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "Views",
    transform: "translate(183 234)",
    fill: "#989898",
    fontSize: 12,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.927,
    y: 0
  }, "Views"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12830",
    "data-name": "Group 12830",
    transform: "translate(120 45.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11099",
    "data-name": "Path 11099",
    d: "M118.907,46.827c-1.021-1.2-25.413-29.452-56.181-29.452S7.566,45.624,6.545,46.827a2.269,2.269,0,0,0,0,2.95c1.021,1.2,25.413,29.429,56.181,29.429s55.16-28.227,56.181-29.429A2.269,2.269,0,0,0,118.907,46.827Z",
    transform: "translate(0)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "#4051a5",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11100",
    "data-name": "Path 11100",
    d: "M42.777,63.828A21.057,21.057,0,1,1,63.81,42.794,21.067,21.067,0,0,1,42.777,63.828Z",
    transform: "translate(19.949 5.508)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11127",
    "data-name": "Path 11127",
    d: "M35.7,49.672A13.979,13.979,0,1,1,49.662,35.709,13.986,13.986,0,0,1,35.7,49.672Z",
    transform: "translate(27.023 12.585)",
    fill: "#4051a5",
    stroke: "#4051a5",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.917f2e617bdda350f7bbaf907cabbe81.svg";
export { ForwardRef as ReactComponent };